<div class="reservation-resume-wrapper">

  <!-- Header fijo -->
  <div class="reservation-header">
    <div class="header-top-row">
      <div class="mode-badge">
        <fa-icon [icon]="faBookmark"></fa-icon>
        <span>Modo reserva</span>
      </div>
      <div class="header-top-actions">
        <button class="btn-cart-action btn-clean" *ngIf="lines.length > 0" (click)="clearLines()" [disabled]="clearingAll" title="Limpiar reserva">
          <mat-progress-spinner *ngIf="clearingAll" diameter="16" mode="indeterminate" color="accent"></mat-progress-spinner>
          <fa-icon *ngIf="!clearingAll" [icon]="faCartXmark"></fa-icon>
        </button>
        <button class="btn-cart-action btn-exit-reservation" (click)="exitToSaleHome()" title="Salir del modo reserva">
          <fa-icon [icon]="faExit"></fa-icon>
        </button>
      </div>
    </div>
    <p class="reservation-name">{{ reservation?.name || '...' }}</p>
  </div>

  <!-- Scrollable lines -->
  <div class="resume-lines-wrapper px-4 pb-4">

    <!-- Loading -->
    <div class="empty-reservation" *ngIf="loading">
      <mat-progress-spinner color="accent" mode="indeterminate" diameter="36"></mat-progress-spinner>
    </div>

    <!-- Empty state -->
    <div class="empty-reservation" *ngIf="!loading && lines.length === 0">
      <fa-icon [icon]="faTicket" class="empty-reservation-icon"></fa-icon>
      <p class="empty-reservation-title">Reserva vacía</p>
      <p class="empty-reservation-subtitle">Selecciona entradas o asientos para añadirlos a la reserva</p>
    </div>

    <!-- Grouped lines -->
    <div *ngIf="!loading && lines.length > 0">
      <div *ngFor="let group of groupedLines; trackBy: trackByGroup" class="event-group-wrapper">

        <div class="event-group-header" (click)="toggleGroup(group.groupKey)">
          <div class="event-group-img">
            <img *ngIf="group.event?.image_url" [src]="urlImages + group.event.image_url" />
            <div class="event-group-img-placeholder" *ngIf="!group.event?.image_url">
              <fa-icon [icon]="faTicket"></fa-icon>
            </div>
          </div>
          <div class="event-group-info">
            <span class="event-group-title">{{ group.event?.title }}</span>
            <span class="event-group-session">
              <fa-icon [icon]="faCalendar"></fa-icon>
              {{ group.session?.start_date | date:'dd MMM yyyy · HH:mm':'+0000' }}h
            </span>
            <span class="event-group-quantity">
              {{ group.quantityTotal }} entrada{{ group.quantityTotal > 1 ? 's' : '' }}
            </span>
          </div>
          <span class="event-group-total">{{ formatNumber(group.total) }}</span>
          <fa-icon class="event-group-chevron" [icon]="faChevron" [class.rotated]="!group.expanded"></fa-icon>
        </div>

        <div *ngIf="group.expanded">
          <div *ngFor="let line of group.lines; trackBy: trackByLine" class="resume-event-wrapper py-2">
            <div class="event-resume">
              <div class="er-main">
                <div class="er-title">
                  <p class="m-0 ticket-name">
                    {{ line.ticket?.name || '—' }}
                    <span *ngIf="line.quantity && line.quantity > 1" class="qty-badge">(x{{ line.quantity }})</span>
                  </p>
                </div>
                <div class="seat-info" *ngIf="line.bookings?.[0]?.seat as seat">
                  <div class="seat-info-row seat-info-row--main">
                    <fa-icon [icon]="faSeat"></fa-icon>
                    <span *ngIf="(seat.map_section?.name || seat.section?.name) as sectionName">{{ sectionName }}</span>
                  </div>
                  <div class="seat-info-row seat-info-row--sub" *ngIf="seat.row || seat.seat">
                    <span *ngIf="seat.row">Fila: {{ seat.row }}</span>
                    <span *ngIf="seat.row && seat.seat">·</span>
                    <span *ngIf="seat.seat">Butaca: {{ seat.seat }}</span>
                  </div>
                </div>
              </div>
              <div class="er-side">
                <div class="total-price">
                  <p class="m-0">{{ (+line.price - +line.fee) | number:'1.2-2' }} €</p>
                </div>
                <button type="button" class="remove-btn" (click)="deleteLine(line.id)" [disabled]="deletingLineId === line.id || clearingAll" title="Eliminar">
                  <mat-progress-spinner *ngIf="deletingLineId === line.id" diameter="16" mode="indeterminate" color="accent"></mat-progress-spinner>
                  <fa-icon *ngIf="deletingLineId !== line.id" class="remove-icon" [icon]="faTrash"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="reservation-footer" *ngIf="!loading && lines.length > 0">
    <div class="totals-row">
      <span class="totals-label">{{ totalQuantity }} entrada{{ totalQuantity !== 1 ? 's' : '' }}</span>
      <span class="totals-value-total">{{ formatNumber(total) }}</span>
    </div>
    <div class="footer-actions">
      <button class="btn-action btn-action--danger" (click)="exitReservationMode()">
        <fa-icon [icon]="faTrash"></fa-icon>
        Cancelar reserva
      </button>
      <button class="btn-action btn-action--primary" (click)="goToReservation()">
        <fa-icon [icon]="faBookmark"></fa-icon>
        Gestionar reserva
      </button>
    </div>
  </div>

  <div class="reservation-footer" *ngIf="!loading && lines.length === 0">
    <div class="footer-actions">
      <button class="btn-action btn-action--danger" (click)="exitReservationMode()">
        <fa-icon [icon]="faTrash"></fa-icon>
        Cancelar reserva
      </button>
    </div>
  </div>

</div>
